import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { ConsulateClient } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.ConsolatoQuery],
  create: [SystemAuthorizations.ConsolatoAdd],
  edit: [SystemAuthorizations.ConsolatoUpdate],
  delete: [SystemAuthorizations.ConsolatoDelete],
});

export const headCells: HeadCell<ConsulateClient, keyof ConsulateClient>[] = [
  {
    id: 'code',
    label: 'Consolato',
  },
  {
    id: 'description',
    label: 'Nome consolato',
  },
  {
    id: 'municipality',
    label: 'Comune',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaConsulateFilter = yup.object({
  code: yup.string(),
  municipality: yup.object().shape({}).nullable(true),
});
